import { useEffect, useState, useCallback } from 'react'

interface Slide {
  src: string
  alt: string
  caption: string
}

const slides: Slide[] = [
  {
    src: '/images/cloud-infrastructure.jpg',
    alt: 'Cloud data centre infrastructure',
    caption: 'Cloud-based solutions, built to scale',
  },
  {
    src: '/images/custom-development.jpg',
    alt: 'Developer working on custom software',
    caption: 'Custom development, tailored to your business',
  },
  {
    src: '/images/ai-automation.jpg',
    alt: 'Abstract visualisation of artificial intelligence',
    caption: 'AI woven in — more output, less manual effort',
  },
]

const AUTO_ADVANCE_MS = 6000

export function Carousel() {
  const [index, setIndex] = useState(0)

  const go = useCallback((next: number) => {
    setIndex((next + slides.length) % slides.length)
  }, [])

  useEffect(() => {
    const timer = setInterval(() => setIndex((i) => (i + 1) % slides.length), AUTO_ADVANCE_MS)
    return () => clearInterval(timer)
  }, [])

  return (
    <div
      className="carousel"
      role="region"
      aria-roledescription="carousel"
      aria-label="Stratum Labs highlights"
    >
      <div className="carousel__viewport">
        {slides.map((slide, i) => (
          <div
            key={slide.src}
            className={`carousel__slide${i === index ? ' carousel__slide--active' : ''}`}
            aria-hidden={i !== index}
          >
            <img
              className="carousel__img"
              src={slide.src}
              alt={slide.alt}
              loading={i === 0 ? 'eager' : 'lazy'}
            />
            <p className="carousel__caption">{slide.caption}</p>
          </div>
        ))}
      </div>

      <button
        type="button"
        className="carousel__arrow carousel__arrow--prev"
        aria-label="Previous slide"
        onClick={() => go(index - 1)}
      >
        &#8249;
      </button>
      <button
        type="button"
        className="carousel__arrow carousel__arrow--next"
        aria-label="Next slide"
        onClick={() => go(index + 1)}
      >
        &#8250;
      </button>

      <div className="carousel__dots" role="tablist" aria-label="Choose slide">
        {slides.map((slide, i) => (
          <button
            key={slide.src}
            type="button"
            role="tab"
            aria-selected={i === index}
            aria-label={`Go to slide ${i + 1}`}
            className={`carousel__dot${i === index ? ' carousel__dot--active' : ''}`}
            onClick={() => go(i)}
          />
        ))}
      </div>
    </div>
  )
}
